var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _defs2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle3, _circle4, _defs3, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle5, _circle6, _defs4, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle7, _circle8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDsaasLogoNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 480",
    style: {
      enableBackground: "new 0 0 1200 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;clip-path:url(#SVGID_00000132783839627604352900000001524213838074600841_);}\n\t.st3{fill:url(#SVGID_00000178180737286574256430000005755862305070147734_);}\n\t.st4{fill:url(#SVGID_00000159464358791918965010000004532271457558294455_);}\n\t.st5{display:inline;clip-path:url(#SVGID_00000146484848791674789610000010804292930965357953_);}\n\t.st6{fill:url(#SVGID_00000171709125289575634020000014675809039938935215_);}\n\t.st7{fill:url(#SVGID_00000010283207101781738050000015188825919256611738_);}\n\t.st8{display:inline;clip-path:url(#SVGID_00000156550434974126630380000006731965584454141323_);}\n\t.st9{fill:url(#SVGID_00000152223133449544794030000011079361999717994633_);}\n\t.st10{fill:url(#SVGID_00000036942424051611760200000000616910122805135280_);}\n\t.st11{clip-path:url(#SVGID_00000109006341383650713860000010066689380636873121_);}\n\t.st12{fill:url(#SVGID_00000128475656391241223600000013932682916221774217_);}\n\t.st13{fill:url(#SVGID_00000175290341016433911340000013508811016044208816_);}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 2807.2,
    y: 1058.3,
    width: 236.1,
    height: 85.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003106717040303555020000006333456806754621599_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000003106717040303555020000006333456806754621599_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2906.9,1130.4h-6.7v-1c0-6.6,0.1-13.1,0-19.7c0-1.6-0.3-3.2-0.8-4.8c-0.6-1.9-2.2-3-4.2-3.2c-1.9-0.3-3.8-0.1-5.6,0.9 c-2,1-3,2.7-3,4.9c0,7.4,0,14.7,0,22.1v0.9h-6.7v-1c0-6.5,0-13,0-19.5c0-1.8-0.2-3.5-0.9-5.2c-0.8-1.6-2-2.6-3.8-2.9 c-2.2-0.4-4.3-0.1-6.2,1c-1.8,1.1-2.7,2.7-2.7,4.8c0,7.3,0,14.6,0,22c0,0.3,0,0.6,0,0.9h-6.5v-33.7h6.6v5.5c0.1,0,0.2,0.1,0.2,0.1 c1.8-4.3,4.9-6.8,9.7-6.5c4.6,0.3,7.9,2.4,9.6,6.9c1.3-3,3.2-5.3,6.3-6.2c4-1.2,7.8-1,11.1,1.9c2.1,1.8,3,4.3,3.4,7 c0.2,1.3,0.3,2.6,0.3,3.9c0,6.7,0,13.4,0,20.1L2906.9,1130.4L2906.9,1130.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2923.6,1124.9v18.4h-6.6v-46.7h6.6v5.4c0.1,0,0.2,0,0.2,0c0.1-0.2,0.3-0.5,0.4-0.7c1.4-3.1,3.8-4.8,7.1-5.4 c6.3-1.1,11.6,1.9,14.1,7.8c1.6,3.8,1.9,7.8,1.6,11.9c-0.2,2.6-0.6,5.1-1.6,7.4c-1.7,4.1-4.6,7-9.1,7.8c-3.4,0.6-6.8,0.3-9.5-2.1 c-1-0.9-1.7-2.1-2.5-3.2c-0.2-0.2-0.3-0.5-0.4-0.7C2923.8,1124.9,2923.7,1124.9,2923.6,1124.9L2923.6,1124.9z M2940,1113.5 c0,0-0.1,0-0.1,0c0-1.4,0.1-2.7,0-4.1c-0.3-3.3-1.7-5.9-4.9-7.2c-2.5-1-5.1-0.9-7.6,0.2c-2.6,1.1-3.9,3-3.9,6 c0.1,3.5,0,7.1,0,10.6c0,2.5,1.1,4.2,3.2,5.4c1.4,0.8,3,1.1,4.6,1.1c4.5,0.1,7.6-2.5,8.4-6.9 C2940,1116.9,2939.9,1115.2,2940,1113.5L2940,1113.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3016,1137.9c1.6,0,3.2,0,4.8,0c0.6,0,0.9-0.2,1-0.8c0.5-1.5,1.1-3.1,1.6-4.6c0.1-0.5,0.1-1,0-1.5 c-3.9-11.1-7.8-22.2-11.7-33.3c-0.1-0.3-0.2-0.7-0.4-1.2h4.4c1.5,0,2.6,0.7,3.1,2.2c2,5.9,4.1,11.8,6,17.7 c0.7,2.2,1.3,4.4,1.9,6.6c0.1,0.3,0.2,0.7,0.5,1c0.1-0.2,0.2-0.4,0.3-0.7c2.9-8.7,5.8-17.4,8.7-26.2c0.2-0.5,0.4-0.7,1-0.7 c1.8,0,3.7,0,5.6,0c-0.1,0.3-0.1,0.6-0.2,0.8c-4.8,13.5-9.5,27-14.3,40.5c-0.3,0.7-0.6,1.4-1,2.1c-1,2-2.7,3.1-4.9,3.3 c-2.1,0.2-4.2,0.2-6.4,0.3L3016,1137.9L3016,1137.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2807.2,1124.7c1.5-1.3,2.9-2.6,4.2-3.7c1.6,1.2,2.9,2.5,4.5,3.4c2.8,1.6,5.9,1.7,9,0.7c1.8-0.6,2.7-2.1,2.7-4.1 c0-1.7-0.9-3.3-2.6-3.8c-1.5-0.5-3.2-0.6-4.8-1c-2-0.5-4.1-0.8-6-1.6c-4.1-1.6-6.1-4.9-5.7-9.4c0.4-4.6,3.1-7.7,7.8-8.9 c3.9-1,7.8-0.9,11.6,0.7c2.2,0.9,4,2.4,5.4,3.9c-1.3,1.4-2.6,2.8-3.8,4.2c-1.6-1.6-3.3-2.9-5.4-3.5c-2.2-0.6-4.4-0.6-6.5,0.2 c-1.7,0.7-2.5,2-2.5,3.7c0,1.7,0.6,3.1,2.3,3.6c1.9,0.6,3.9,1,5.9,1.4c2.3,0.4,4.5,0.8,6.6,1.9c2.7,1.5,4.1,3.8,4.4,6.9 c0.5,5.8-3.2,10.2-9.3,11.4c-3.3,0.6-6.6,0.5-9.8-0.5C2811.7,1129.3,2809.3,1127.3,2807.2,1124.7L2807.2,1124.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2999.4,1096.5h7v5.5h-7v28.3h-6.7v-28.2h-5.2v-5.5h5.2c0-2-0.1-3.9,0-5.7c0-1.2,0.2-2.4,0.5-3.5c0.8-2.8,3.1-4.8,6-5 c2.4-0.1,4.8,0,7.2,0v5.4h-7L2999.4,1096.5L2999.4,1096.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2962,1124.9h4.7v5.6c-2.2-0.1-4.5-0.1-6.7-0.4c-2.4-0.3-3.9-2-4.5-4.3c-0.2-0.6-0.2-1.3-0.2-2c0-13.7,0-27.3,0-41 c0-0.2,0-0.4,0.1-0.6h6.6L2962,1124.9L2962,1124.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2980.4,1096.6v33.7h-6.5v-33.7H2980.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2849,1130.3h-6.5v-33.7h6.5V1130.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149371656220871748410000014794054735446587009_",
    gradientUnits: "userSpaceOnUse",
    x1: 2560.905,
    y1: -437.1638,
    x2: 2593.2793,
    y2: -429.828,
    gradientTransform: "matrix(1 0 0 -1 287 652.1318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0686FF",
      stopOpacity: 0.37
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    style: {
      stopColor: "#0686FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149371656220871748410000014794054735446587009_)"
    },
    d: "M2846,1091.2c-0.8,0-1.5-0.3-2.2-0.8 c-1.4-1.2-1.5-3.3-0.3-4.6c1.9-2.2,9.1-9.4,20.4-9.9c13.1-0.6,21.5,8.1,23,9.9c1.2,1.4,1.1,3.4-0.3,4.6c-1.4,1.2-3.4,1.1-4.6-0.3 c-1.2-1.4-7.7-8.1-17.8-7.7c-8.8,0.4-14.3,6-15.8,7.7C2847.8,1090.8,2846.9,1091.2,2846,1091.2z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2846,
    cy: 1087.8,
    r: 3.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170988776263272662910000003174165799116290729_",
    gradientUnits: "userSpaceOnUse",
    x1: 2681.8953,
    y1: -450.4766,
    x2: 2606.5344,
    y2: -412.3485,
    gradientTransform: "matrix(1 0 0 -1 287 652.1318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0686FF",
      stopOpacity: 0.37
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2016,
    style: {
      stopColor: "#0686FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170988776263272662910000003174165799116290729_)"
    },
    d: "M2884.5,1091.3c1.1,0,2.2-0.6,2.8-1.6 c9.6-15.8,26.8-25.3,45.1-24.8c27.3,0.8,41.5,23.8,42.1,24.8c0.9,1.6,3,2,4.5,1.1s2-3,1.1-4.5c-0.7-1.1-16.7-27-47.5-27.9 c-20.6-0.6-40.1,10.1-50.9,27.9c-0.9,1.6-0.4,3.6,1.1,4.5C2883.4,1091.1,2884,1091.3,2884.5,1091.3z"
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2977.1,
    cy: 1087.8,
    r: 3.8
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000170962464242621903330000011234144200308471943_",
    x: 1727.9,
    y: 987.2,
    width: 629.7,
    height: 227.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057831328711734762040000004408868180790106003_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170962464242621903330000011234144200308471943_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000057831328711734762040000004408868180790106003_)"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1993.9,1179.4h-18v-2.8c0-17.5,0.1-35-0.1-52.5c-0.1-4.2-0.9-8.6-2.2-12.7c-1.6-5.2-5.8-7.9-11.1-8.7 c-5.2-0.7-10.2-0.2-14.9,2.3c-5.2,2.8-8,7.1-8,13.1c0,19.6,0,39.2,0,58.8v2.3h-17.9v-2.8c0-17.4,0-34.7,0-52.1 c0-4.8-0.4-9.4-2.5-13.8c-2-4.3-5.5-6.9-10.1-7.7c-5.8-1-11.5-0.3-16.6,2.8c-4.8,2.8-7.2,7.1-7.2,12.7c0,19.5,0,39.1,0,58.6 c0,0.8-0.1,1.5-0.1,2.4h-17.4v-89.9h17.6v14.6c0.2,0.1,0.4,0.2,0.6,0.4c4.9-11.5,13-18,25.8-17.3c12.3,0.7,21.1,6.4,25.6,18.3 c3.5-8,8.7-14.1,16.9-16.6c10.6-3.2,20.9-2.8,29.7,5c5.5,4.9,8.1,11.4,9.1,18.6c0.5,3.4,0.7,6.9,0.8,10.4c0.1,17.8,0,35.7,0,53.5 L1993.9,1179.4L1993.9,1179.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2038.5,1165v49.1h-17.7v-124.7h17.7v14.5c0.2,0,0.4,0.1,0.6,0.1c0.3-0.6,0.7-1.3,1-1.9c3.7-8.2,10.2-12.9,19-14.4 c16.9-2.9,31,5.1,37.5,20.9c4.2,10.2,5,20.9,4.3,31.7c-0.4,6.8-1.6,13.5-4.4,19.9c-4.7,10.9-12.2,18.6-24.3,20.8 c-9.2,1.6-18.1,0.9-25.4-5.7c-2.6-2.4-4.5-5.6-6.7-8.5c-0.4-0.6-0.7-1.3-1-1.9C2039,1164.8,2038.8,1164.9,2038.5,1165L2038.5,1165 z M2082.4,1134.4c-0.1,0-0.2,0-0.3,0c0-3.6,0.2-7.3,0-10.9c-0.7-8.8-4.5-15.8-13-19.3c-6.7-2.8-13.7-2.4-20.4,0.5 c-7,3-10.5,8.1-10.3,16c0.3,9.4,0.1,18.9,0.1,28.4c0,6.5,3,11.2,8.6,14.3c3.8,2.1,8,2.9,12.3,2.9c11.9,0.2,20.3-6.6,22.3-18.4 C2082.3,1143.5,2082.2,1138.9,2082.4,1134.4L2082.4,1134.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2285.1,1199.6c4.4,0,8.6-0.1,12.9,0c1.6,0.1,2.3-0.6,2.8-2c1.3-4.1,2.9-8.2,4.2-12.3c0.4-1.2,0.4-2.8,0-4 c-10.3-29.7-20.8-59.3-31.2-88.9c-0.3-0.9-0.6-1.9-1-3.2h11.6c4.1,0,6.8,1.9,8.2,5.8c5.4,15.7,10.8,31.5,16.1,47.2 c1.9,5.8,3.3,11.7,5,17.6c0.3,0.9,0.6,1.8,1.4,2.8c0.3-0.6,0.6-1.2,0.8-1.7c7.8-23.2,15.6-46.5,23.3-69.8c0.5-1.4,1-2,2.6-1.9 c4.9,0.1,9.8,0,14.9,0c-0.2,0.8-0.3,1.5-0.6,2.1c-12.7,36-25.4,72-38.1,107.9c-0.7,2-1.7,3.8-2.7,5.7c-2.7,5.3-7.2,8.3-13.1,8.8 c-5.6,0.5-11.3,0.5-17.1,0.8L2285.1,1199.6L2285.1,1199.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1727.9,1164.4c4-3.5,7.7-6.9,11.1-9.9c4.2,3.2,7.8,6.6,12,9c7.6,4.3,15.8,4.7,24.1,1.8c4.9-1.7,7.2-5.6,7.3-11 c0-4.7-2.4-8.7-7-10.1c-4.1-1.3-8.5-1.6-12.7-2.6c-5.4-1.2-11-2.2-16.1-4.2c-11-4.2-16.2-13.1-15.2-24.9 c1-12.1,8.2-20.6,20.7-23.7c10.4-2.6,20.7-2.3,30.8,1.7c5.9,2.3,10.6,6.3,14.3,10.4c-3.5,3.8-6.8,7.5-10.2,11.2 c-4.2-4.4-8.7-7.8-14.4-9.3c-5.8-1.5-11.7-1.7-17.4,0.6c-4.5,1.8-6.6,5.3-6.7,10c-0.1,4.5,1.7,8.3,6.1,9.7 c5.1,1.6,10.5,2.7,15.8,3.6c6,1.1,12,2.1,17.5,5.1c7.3,4,11,10.2,11.6,18.4c1.3,15.5-8.4,27.3-24.8,30.5 c-8.8,1.7-17.6,1.4-26.2-1.4C1740.2,1176.5,1733.6,1171.2,1727.9,1164.4L1727.9,1164.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2240.8,1089.2h18.6v14.8h-18.7v75.4h-17.8v-75.2h-14v-14.8h13.9c0-5.3-0.2-10.3,0.1-15.3c0.1-3.1,0.5-6.3,1.3-9.4 c2.1-7.6,8.3-12.8,16.1-13.3c6.3-0.4,12.7-0.1,19.2-0.1v14.3h-18.6L2240.8,1089.2L2240.8,1089.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2141,1164.8h12.6v15c-6-0.3-11.9-0.1-17.8-1c-6.5-0.9-10.3-5.2-11.9-11.5c-0.4-1.7-0.6-3.5-0.6-5.3 c0-36.4,0-72.8,0-109.3c0-0.5,0.1-1,0.1-1.7h17.6L2141,1164.8L2141,1164.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2190,1089.4v89.9h-17.4v-89.9H2190z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.5,1179.4h-17.4v-89.9h17.4V1179.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038406086144824434660000001986169827423662470_",
    gradientUnits: "userSpaceOnUse",
    x1: 1549.6548,
    y1: -417.7545,
    x2: 1636.01,
    y2: -398.187,
    gradientTransform: "matrix(1 0 0 -1 287 652.1318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0686FF",
      stopOpacity: 0.37
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    style: {
      stopColor: "#0686FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038406086144824434660000001986169827423662470_)"
    },
    d: "M1831.4,1074.9c-2.1,0-4.1-0.7-5.8-2.2 c-3.6-3.2-4-8.7-0.8-12.3c5.1-5.8,24.2-25,54.5-26.3c35-1.6,57.3,21.6,61.5,26.3c3.2,3.6,2.9,9.1-0.8,12.3 c-3.6,3.2-9.2,2.9-12.3-0.8c-3.2-3.6-20.5-21.6-47.6-20.4c-23.4,1-38.2,15.9-42.2,20.4C1836.3,1073.9,1833.9,1074.9,1831.4,1074.9 z"
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1831.4,
    cy: 1066,
    r: 10.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003091494492971780190000004706574010930615217_",
    gradientUnits: "userSpaceOnUse",
    x1: 1872.3835,
    y1: -453.2649,
    x2: 1671.3667,
    y2: -351.5622,
    gradientTransform: "matrix(1 0 0 -1 287 652.1318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0686FF",
      stopOpacity: 0.37
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2016,
    style: {
      stopColor: "#0686FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003091494492971780190000004706574010930615217_)"
    },
    d: "M1934.4,1075.1c3,0,5.8-1.5,7.5-4.2 c25.5-42.2,71.6-67.5,120.3-66.1c72.9,2.1,110.7,63.5,112.3,66.1c2.5,4.1,7.9,5.5,12,3c4.1-2.5,5.5-7.9,3-12 c-1.8-2.9-44.4-72.1-126.8-74.5c-55-1.6-107,26.9-135.8,74.5c-2.5,4.1-1.2,9.5,3,12C1931.2,1074.7,1932.8,1075.1,1934.4,1075.1z"
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2181.3,
    cy: 1066,
    r: 10.2
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000041991369698716176440000014096223701640383388_",
    x: 53.3,
    y: 892.2,
    width: 1156.2,
    height: 417.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093891230131621592160000015614374696733580963_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041991369698716176440000014096223701640383388_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000093891230131621592160000015614374696733580963_)"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M541.7,1245h-33v-5.1c0-32.2,0.3-64.3-0.2-96.5c-0.1-7.8-1.7-15.8-4.1-23.3c-3-9.5-10.7-14.5-20.4-15.9 c-9.5-1.4-18.8-0.3-27.4,4.2c-9.6,5.1-14.7,13.1-14.6,24.1c0.1,36,0,72,0,108v4.2H409v-5.1c0-31.9,0-63.8,0-95.6 c0-8.7-0.8-17.3-4.6-25.4c-3.7-7.9-10-12.6-18.5-14.2c-10.7-1.9-21-0.5-30.5,5.1c-8.8,5.2-13.2,13.1-13.2,23.3 c0,35.9,0,71.7,0,107.6c0,1.4-0.1,2.8-0.2,4.4h-32v-165.1h32.3v26.9c0.4,0.2,0.8,0.5,1.2,0.7c8.9-21.2,23.8-33.1,47.5-31.7 c22.6,1.3,38.7,11.8,47,33.6c6.5-14.7,15.9-26,31-30.5c19.5-5.8,38.4-5.1,54.6,9.2c10.1,9,14.9,21,16.7,34.2 c0.9,6.3,1.4,12.7,1.4,19.1c0.1,32.7,0.1,65.5,0.1,98.2L541.7,1245L541.7,1245z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M623.6,1218.5v90.2h-32.4v-228.9h32.4v26.6c0.4,0.1,0.8,0.2,1.2,0.2c0.6-1.2,1.2-2.3,1.8-3.5 c6.8-15.1,18.8-23.7,34.8-26.5c31-5.3,56.9,9.3,68.9,38.4c7.7,18.7,9.2,38.3,7.9,58.2c-0.8,12.6-3,24.8-8,36.5 c-8.6,20.1-22.4,34.2-44.6,38.1c-16.8,3-33.2,1.7-46.6-10.4c-4.8-4.4-8.3-10.4-12.3-15.7c-0.8-1-1.3-2.4-1.9-3.6 C624.4,1218.2,624,1218.4,623.6,1218.5L623.6,1218.5z M704.1,1162.5c-0.2,0-0.4,0-0.6,0c0-6.7,0.5-13.4-0.1-20 c-1.4-16.1-8.2-29.1-23.9-35.5c-12.4-5.1-25.2-4.4-37.4,0.8c-12.8,5.4-19.3,14.9-18.9,29.4c0.5,17.3,0.2,34.7,0.1,52.1 c-0.1,12,5.5,20.6,15.8,26.3c7,3.9,14.7,5.2,22.6,5.4c21.9,0.3,37.3-12.2,40.9-33.8C704,1179.1,703.7,1170.7,704.1,1162.5 L704.1,1162.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.3,1282.1c8,0,15.8-0.2,23.6,0.1c3,0.1,4.3-1,5.1-3.7c2.4-7.6,5.3-15,7.6-22.6c0.7-2.2,0.7-5.1-0.1-7.3 c-19-54.5-38.2-108.9-57.3-163.3c-0.6-1.7-1.1-3.4-1.8-5.9h21.4c7.6,0,12.6,3.6,15,10.7c9.9,28.9,19.9,57.8,29.5,86.7 c3.5,10.6,6.1,21.6,9.2,32.4c0.5,1.7,1.1,3.4,2.6,5.1c0.5-1.1,1-2.1,1.4-3.2c14.3-42.7,28.6-85.4,42.8-128.2 c0.8-2.5,1.9-3.6,4.8-3.6c9,0.2,17.9,0.1,27.4,0.1c-0.4,1.5-0.6,2.7-1,3.8c-23.3,66.1-46.6,132.1-70,198.1 c-1.3,3.6-3.1,7-4.9,10.4c-5,9.8-13.2,15.3-24,16.2c-10.3,0.9-20.7,1-31.3,1.4L1076.3,1282.1L1076.3,1282.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3,1217.5c7.3-6.5,14.2-12.7,20.4-18.3c7.6,5.8,14.3,12.2,22.1,16.6c13.9,7.9,29,8.6,44.2,3.3 c8.9-3.1,13.3-10.2,13.3-20.3c0.1-8.5-4.4-16-12.9-18.6c-7.5-2.4-15.6-2.9-23.3-4.7c-10-2.3-20.2-4.1-29.6-7.7 c-20.3-7.8-29.8-24.1-28-45.8c1.8-22.3,15-37.8,38.1-43.6c19.1-4.7,38.1-4.2,56.6,3.2c10.8,4.3,19.4,11.6,26.2,19.2 c-6.4,7-12.5,13.7-18.8,20.6c-7.7-8-16-14.4-26.5-17c-10.7-2.7-21.4-3.1-31.9,1c-8.2,3.3-12.1,9.7-12.3,18.3 c-0.2,8.4,3.2,15.2,11.3,17.7c9.4,3,19.2,4.9,29,6.7c11.1,2.1,22.1,3.8,32.2,9.4c13.4,7.4,20.1,18.8,21.4,33.8 c2.4,28.5-15.5,50.2-45.6,55.9c-16.2,3.1-32.4,2.6-48.1-2.5C75.7,1239.7,63.7,1230,53.3,1217.5L53.3,1217.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M994.9,1079.4h34.1v27.1h-34.4v138.5h-32.8v-138.2h-25.6v-27.2h25.5c0-9.7-0.3-18.9,0.1-28.1c0.2-5.8,0.9-11.6,2.4-17.2 c3.8-13.9,15.2-23.5,29.6-24.4c11.6-0.7,23.3-0.1,35.2-0.1v26.3H995L994.9,1079.4L994.9,1079.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M811.7,1218.2h23.2v27.5c-11-0.5-21.9-0.3-32.6-1.8c-11.9-1.7-19-9.6-21.8-21.2c-0.8-3.1-1.2-6.5-1.2-9.7 c-0.1-66.9-0.1-133.7,0-200.6c0-1,0.2-1.9,0.3-3.1h32.2L811.7,1218.2L811.7,1218.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M901.7,1079.7v165.1h-32v-165.1H901.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M258.1,1244.9h-31.9v-165.1h31.9V1244.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115508754184660193670000002766630206084822149_",
    gradientUnits: "userSpaceOnUse",
    x1: -34.1231,
    y1: -391.7924,
    x2: 124.4373,
    y2: -355.8639,
    gradientTransform: "matrix(1 0 0 -1 287 652.1318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0686FF",
      stopOpacity: 0.37
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    style: {
      stopColor: "#0686FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115508754184660193670000002766630206084822149_)"
    },
    d: "M243.3,1053.1c-3.8,0-7.5-1.3-10.6-4 c-6.7-5.9-7.3-16-1.4-22.7c9.4-10.7,44.5-45.8,100.1-48.3c64.2-2.9,105.3,39.7,112.8,48.3c5.9,6.6,5.2,16.8-1.4,22.7 c-6.6,5.9-16.8,5.2-22.7-1.4c-5.9-6.6-37.6-39.7-87.3-37.5c-43,1.9-70.1,29.2-77.4,37.5C252.2,1051.3,247.8,1053.1,243.3,1053.1z"
  }), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.3,
    cy: 1036.7,
    r: 18.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008139576673450327370000012247442935176966819_",
    gradientUnits: "userSpaceOnUse",
    x1: 558.4525,
    y1: -456.9945,
    x2: 189.3573,
    y2: -270.254,
    gradientTransform: "matrix(1 0 0 -1 287 652.1318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0686FF",
      stopOpacity: 0.37
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2016,
    style: {
      stopColor: "#0686FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008139576673450327370000012247442935176966819_)"
    },
    d: "M432.3,1053.5c5.4,0,10.7-2.8,13.8-7.8 c46.8-77.5,131.4-124,220.9-121.4c133.9,3.9,203.3,116.5,206.2,121.3c4.6,7.6,14.5,10,22.1,5.5c7.6-4.6,10-14.5,5.5-22.1 c-3.3-5.4-81.6-132.4-232.7-136.8c-100.9-3-196.5,49.5-249.3,136.8c-4.6,7.6-2.1,17.5,5.4,22.1 C426.6,1052.8,429.4,1053.5,432.3,1053.5z"
  }), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 885.7,
    cy: 1036.7,
    r: 18.7
  })))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147192611860930281460000015447774879085418900_",
    x: 37.8,
    y: 37,
    width: 1124.4,
    height: 406
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102526833975413965520000002943029153236025500_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147192611860930281460000015447774879085418900_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000102526833975413965520000002943029153236025500_)"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M512.7,380.1h-32.1v-4.9c0-31.3,0.3-62.6-0.2-93.8c-0.1-7.6-1.7-15.4-4-22.6c-2.9-9.2-10.4-14.1-19.9-15.5 c-9.2-1.3-18.3-0.3-26.7,4.1c-9.3,4.9-14.3,12.7-14.2,23.5c0.1,35,0,70,0,105.1v4.1h-32V375c0-31,0-62,0-93 c0-8.5-0.8-16.8-4.5-24.7c-3.6-7.7-9.8-12.3-18-13.8c-10.4-1.9-20.5-0.5-29.7,4.9c-8.6,5-12.8,12.7-12.8,22.7 c0,34.9,0,69.8,0,104.6c0,1.4-0.1,2.7-0.2,4.3h-31.1V219.5h31.4v26.1c0.4,0.2,0.8,0.4,1.1,0.7c8.7-20.6,23.2-32.2,46.1-30.8 c22,1.3,37.6,11.5,45.7,32.7c6.3-14.3,15.5-25.2,30.2-29.6c18.9-5.7,37.4-5,53.1,9c9.8,8.7,14.5,20.4,16.2,33.2 c0.9,6.1,1.3,12.4,1.4,18.6c0.1,31.8,0.1,63.7,0.1,95.5L512.7,380.1L512.7,380.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M592.4,354.3V442h-31.5V219.4h31.5v25.9c0.4,0.1,0.8,0.2,1.1,0.2c0.6-1.1,1.2-2.3,1.7-3.4c6.6-14.7,18.3-23.1,33.9-25.7 c30.1-5.1,55.3,9,67,37.3c7.5,18.2,9,37.2,7.7,56.6c-0.8,12.2-2.9,24.2-7.8,35.5c-8.3,19.5-21.8,33.2-43.4,37.1 c-16.4,2.9-32.3,1.6-45.3-10.2c-4.7-4.3-8-10.1-11.9-15.2c-0.8-1-1.2-2.3-1.8-3.5C593.2,354.1,592.8,354.2,592.4,354.3 L592.4,354.3z M670.7,299.8c-0.2,0-0.4,0-0.5,0c0-6.5,0.4-13-0.1-19.5c-1.3-15.7-8-28.3-23.2-34.5c-12.1-4.9-24.5-4.3-36.4,0.8 c-12.4,5.3-18.8,14.5-18.3,28.6c0.5,16.9,0.2,33.8,0.1,50.6c-0.1,11.7,5.4,20,15.3,25.6c6.8,3.8,14.3,5.1,22,5.2 c21.3,0.3,36.3-11.8,39.8-32.8C670.6,316,670.3,307.9,670.7,299.8L670.7,299.8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.7,416.2c7.8,0,15.4-0.2,23,0.1c2.9,0.1,4.1-1,5-3.6c2.4-7.4,5.2-14.6,7.4-22c0.7-2.2,0.7-4.9-0.1-7.1 c-18.5-53-37.1-105.9-55.7-158.8c-0.6-1.6-1.1-3.3-1.8-5.7h20.8c7.4,0,12.2,3.5,14.6,10.4c9.6,28.1,19.3,56.2,28.7,84.4 c3.4,10.3,6,21,8.9,31.5c0.5,1.7,1,3.3,2.6,4.9c0.5-1,1-2.1,1.4-3.1c13.9-41.5,27.8-83.1,41.6-124.6c0.8-2.4,1.9-3.5,4.6-3.5 c8.7,0.2,17.4,0.1,26.7,0.1c-0.4,1.5-0.6,2.6-1,3.7c-22.7,64.2-45.3,128.5-68,192.7c-1.2,3.5-3,6.8-4.8,10.1 c-4.9,9.5-12.9,14.9-23.3,15.8c-10,0.9-20.1,0.9-30.5,1.4L1032.7,416.2L1032.7,416.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8,353.3c7.1-6.3,13.8-12.4,19.8-17.8c7.4,5.7,13.9,11.9,21.5,16.1c13.6,7.7,28.2,8.3,42.9,3.3c8.7-3,12.9-9.9,13-19.7 c0.1-8.3-4.3-15.5-12.5-18.1c-7.3-2.3-15.2-2.8-22.7-4.6c-9.7-2.2-19.6-4-28.8-7.5c-19.7-7.5-29-23.5-27.2-44.5 c1.8-21.7,14.6-36.8,37-42.4c18.5-4.6,37-4.1,55.1,3.1c10.5,4.2,18.9,11.2,25.5,18.6c-6.2,6.8-12.2,13.4-18.2,20 c-7.5-7.8-15.5-14-25.8-16.6c-10.4-2.6-20.8-3-31,1c-8,3.2-11.7,9.4-11.9,17.8c-0.2,8.1,3.1,14.8,11,17.3 c9.2,2.9,18.7,4.7,28.2,6.5c10.7,2,21.5,3.7,31.3,9.1c13,7.2,19.6,18.3,20.8,32.8c2.4,27.7-15,48.8-44.3,54.4 c-15.7,3-31.5,2.6-46.8-2.4C59.6,374.9,47.9,365.5,37.8,353.3L37.8,353.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M953.5,219h33.2v26.4h-33.4V380h-31.9V245.7h-24.9v-26.4h24.8c0-9.4-0.3-18.4,0.1-27.3c0.2-5.6,0.9-11.3,2.4-16.7 c3.7-13.5,14.8-22.9,28.8-23.7c11.3-0.7,22.6-0.1,34.3-0.1v25.6h-33.2L953.5,219L953.5,219z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M775.4,354h22.5v26.7c-10.7-0.5-21.3-0.3-31.7-1.7c-11.5-1.6-18.5-9.4-21.2-20.6c-0.8-3-1.1-6.3-1.1-9.4 c-0.1-65-0.1-130.1,0-195.1c0-0.9,0.2-1.9,0.3-3h31.3L775.4,354L775.4,354z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M862.8,219.3v160.6h-31.2V219.3H862.8z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M236.9,380h-31V219.5h31V380z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113333151052655242950000003139707940307902092_",
    gradientUnits: "userSpaceOnUse",
    x1: -55.109,
    y1: 467.5746,
    x2: 99.0873,
    y2: 502.5143,
    gradientTransform: "matrix(1 0 0 -1 287 652.1318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A5D3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    style: {
      stopColor: "#0686FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113333151052655242950000003139707940307902092_)"
    },
    d: "M222.6,193.5c-3.7,0-7.3-1.3-10.3-3.9 c-6.5-5.7-7.1-15.6-1.4-22c9.2-10.4,43.3-44.6,97.3-47c62.5-2.8,102.4,38.7,109.7,47c5.7,6.5,5.1,16.3-1.4,22 c-6.5,5.7-16.3,5.1-22-1.4c-5.7-6.5-36.6-38.6-84.9-36.5c-41.8,1.9-68.2,28.4-75.3,36.4C231.2,191.7,226.9,193.5,222.6,193.5z"
  }), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.6,
    cy: 177.5,
    r: 18.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060734748987968771010000006779845241802494399_",
    gradientUnits: "userSpaceOnUse",
    x1: 521.1569,
    y1: 404.1671,
    x2: 162.2204,
    y2: 585.7678,
    gradientTransform: "matrix(1 0 0 -1 287 652.1318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A5D3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2016,
    style: {
      stopColor: "#0686FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060734748987968771010000006779845241802494399_)"
    },
    d: "M406.3,193.9c5.3,0,10.4-2.7,13.4-7.5 c45.5-75.4,127.8-120.6,214.8-118c130.2,3.8,197.7,113.3,200.5,118c4.5,7.4,14.1,9.8,21.4,5.3c7.4-4.5,9.8-14.1,5.3-21.4 c-3.2-5.3-79.3-128.8-226.3-133.1C537.3,34.2,444.3,85.2,393,170.2c-4.5,7.4-2.1,17,5.3,21.4C400.8,193.2,403.6,193.9,406.3,193.9 z"
  }), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.3,
    cy: 177.5,
    r: 18.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsaasLogoNew);
export default __webpack_public_path__ + "static/media/Dsaas-LOGO-new.85af356cd6b6d8dc981a6bd7be2bc893.svg";
export { ForwardRef as ReactComponent };